import React from 'react';
import { SoftwareTool } from '../components/SoftwareTool';
import ToolHeader from '../components/ToolHeader';

export default function SoftwarePage() {
  return (
    <>
      <ToolHeader toolName="Software Management" />
      <SoftwareTool />
    </>
  );
}
